<template>
  <div class="UserDetails">
    <h3 class="mb-3 text-right">Detalles de la colocación publica</h3>
    <b-card>
      <b-container fluid>

      </b-container>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import UserBankAccounts from "../components/UserDetails/UserBankAccounts";
// import UserAccounts from "../components/UserDetails/UserAccounts";
// import UserProfileHeader from "../components/UserDetails/UserProfileHeader";
// import UserChat from "../components/UserDetails/UserChat";
// import UserPaymentReports from "../components/UserDetails/UserPaymentReports";
// import UserAuditLog from "../components/UserDetails/UserAuditLog";

export default {
  name: "UserDetails",
  data() {
    return {
      // accountId: "",
      // show_details: false,
    };
  },
  components: {
    // UserProfileHeader,
    // UserBankAccounts,
    // UserAccounts,
    // UserChat,
    // UserPaymentReports,
    // UserAuditLog
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() { },
  methods: {
    // ...mapActions(["GetUser"]),
    // goToAccountDetails(id) {
    //   this.accountId = id;
    //   this.show_details = true;
    // },
  },
};
</script>
<style scoped></style>
